{
  "account": {
    "title": "My Account",
    "list": {
      "title": "Accounts",
      "description": "Linked accounts invoices list"
    },
    "form": {
      "name": {
        "title": "Name",
        "description": "Your account name"
      },
      "password": {
        "title": "Password",
        "description": "Set a new password for your account, leave it empty to keep current password"
      },
      "emailPreferences": {
        "title": "Email preferences",
        "description": "Select email notification types"
      }
    },
    "billing": "Billing details",
    "subscriptions": "Subscriptions",
    "manageSubscription": "Manage subscription",
    "popup": {
      "cancel": "Are you sure to cancel your subscription? <br/>Your website will conftinue to be translated until the end of your current subscription period. After that, translation will be disabled.<br/>Please kindly note that you won't be eligible for a rebate for the unused period.",
      "downgrade": "Are you sure to downgrade? Downgrade will be effective instantly.<br/>Please kindly note that you won't be eligible for a rebate for the remaining time of current billing cycle.<br/>New plan price will be applied on the next billing cycle.",
      "default": "Are you sure you want to change your plan?",
      "resume": "Are you sure to resume your subscription?"
    }
  },
  "ai_translation": {
    "header": "AI Translation",
    "plan": {
      "header": "AI Translation Pricing",
      "used": "You have used {words_used} / {words_allowed} translated words in your AI credits.",
      "remaining": "Available AI credits:",
      "words": "words",
      "add_more_credits": "Add more AI credits",
      "details": {
        "idiomatic_expressions": "Idiomatic and technical expressions",
        "background_translation": "Translations in background",
        "best_website": "Website requiring perfect translation quality",
        "page_context": "Page and website context for translation",
        "perfect_quality": "Perfect quality, affordable price",
        "no_recurring": "No recurring payment, pre-paid quota",
        "save_40": "Save 40% compared to the $20 plan",
        "save_50": "Save 50% compared to the $20 plan"
      },
      "quota": "{estimated_words} words ~ {estimated_pages} pages"
    },
    "settings": {
      "banner": {
        "title": "Linguise AI Translation",
        "intro": "Linguise is excited to unveil Linguise AI Translation, a new premium feature leveraging AI LLM models (Llama most recent models, optimized for translation tasks). Designed for websites demanding flawless accuracy, it considers both page and entire website context for unparalleled results. Offer your clients the pinnacle of translation quality, ensuring their message resonates perfectly in every language.",
        "button": "Upgrade now"
      },
      "alert": {
        "description": "This feature is not included in your current plan and requires a separate purchase.\nActivate this add-on to unlock all options listed below."
      },
      "languages": {
        "title": "Apply AI translation to languages",
        "description": "Select specific language where you want the AI translation to apply"
      },
      "button": {
        "save": "Save settings"
      },
      "form": {
        "advanced": {
          "title": "Advanced AI instructions",
          "description": "Advanced AI instructions"
        },
        "enable_mode": {
          "title": "ENABLE AI TRANSLATION",
          "description": "Choose how you want the AI translation to be enabled.\nRules only will apply the following rules.\nLive editor only will allow enabling translation page per page from the live editor view.\nRules and live editor will use both features.",
          "disabled": "Disabled",
          "rules": "Rules Only",
          "live_editor": "Live editor only",
          "all": "Rules and live editor"
        },
        "rule_application": {
          "description": "Apply the AI Translation on static content or dynamic content or both",
          "title": "Apply to content",
          "all": "All content",
          "static": "Static content",
          "dynamic": "Dynamic content"
        },
        "website_topic": {
          "title": "Website topic",
          "placeholder": "Sushi restaurant...",
          "description": "Define the topic of your website for better translation quality (ex. Legal, sushi restaurant, bike parts Eshop…)\nPlease enter the website topic in English."
        },
        "apply_to_urls": {
          "title": "Apply to URLs",
          "description": "Select specific URLs where you want the AI translation to apply",
          "all_urls": "All URLs",
          "selected_urls": "Selected URLs",
          "label": "Url to apply to",
          "placeholder": "Url to apply to",
          "wildcard": "Wildcard",
          "regex": "Regular expression",
          "add": "Add new",
          "expression": "Expression type"
        },
        "apply_languages": {
          "title": "Apply to languages",
          "description": "Select specific language where you want the AI translation to apply",
          "all_languages": "All languages",
          "selected_languages": "Selected languages",
          "placeholder": "Select languages...",
          "feedback": "You must choose a language"
        },
        "formality": {
          "title": "Formality",
          "description": "Specify the degree of formality in translations, possibly important for audiences and contexts.\n\"Neutral\" will try to preserve the original content/'s formality.\n\"Formal\" is for professional, business, or legal content (i.e. using formal pronouns like \"usted\" in Spanish).\n\"Informal\" is for casual, conversational content (i.e. using \"tú\" in Spanish).",
          "neutral": "Neutral",
          "formal": "Formal",
          "informal": "Informal"
        },
        "sentence_structure": {
          "classic": "Classic",
          "short": "Short and punchy sentences",
          "detailed": "Detailed and explanatory sentences",
          "title": "Sentence structure",
          "description": "Define the writing style preference."
        },
        "content_purpose": {
          "marketing": "Marketing/promotional (persuasive, engaging tone)",
          "technical": "Technical/instructional (clear, precise, action-oriented)",
          "support": "Customer support (empathetic, helpful, reassuring)",
          "legal": "Legal/compliance (precise, formal, unambiguous)",
          "educational": "Educational (clear, structured, accessible)",
          "other": "Other (In English)",
          "title": "Content purpose",
          "description": "Define the functional purpose of the content being translated.",
          "other_placeholder": "Describe the purpose..."
        },
        "target_audience": {
          "title": "Target audience",
          "description": "Specification of the intended audience of the translated content (in English).",
          "placeholder": "e.g., Spanish-speaking parents, EU privacy officers"
        },
        "override_default_translations": {
          "title": "Override default translation",
          "description": "If set to YES this option will force the content to be translated with AI (Linguise AI) even if it has already been translated by Cloud AI translation (default translation model)."
        },
        "force_replace_before": {
          "title": "FORCE AI RE-TRANSLATION",
          "description": "Translate again with AI for any content whose AI translation was made before the selected date — for example content translated with older model. Re-translation happens on the next visit of applied pages depending on the Rules, and use your AI credits.",
          "before_date": "Before a date"
        },
        "model": {
          "current": "Current",
          "title": "Model",
          "description": "Select the LLM translation model you want to use",
          "load_error": "Unable to load available models. Please try again later.",
          "thinking_warning": "This model uses a high level of reasoning (\"thinking\") and will consume significantly more tokens per translation."
        },
        "override_manual_and_selected": {
          "title": "Override manual and selected translations",
          "description": "By default, a translation you edited manually always stays on your website, even after an AI enhanced translation is generated. Set to YES to show the AI enhanced translation instead. Your manual translations are kept and you can switch back at any time. This also affects when you re-translate the pages to get new translations, it would automatically use the latest one.",
          "no_default": "No (default)"
        }
      },
      "message": {
        "save_success": "From the current already translated content, the number of page that would be enhanced with AI translation is around {{ai_affected_urls}}.",
        "save_success_only": "Settings saved successfully."
      }
    },
    "pricing": {
      "plan": {
        "title": "Order AI translation quota",
        "buy_button": "BUY AI TRANSLATION PACKAGE"
      },
      "modal": {
        "title": "Confirm plan change",
        "description": "Are you sure you want to change your AI Translation plan?",
        "button_cancel": "Cancel",
        "button_confirm": "Confirm",
        "loading": "Please wait...",
        "amount": "Amount",
        "credit": "Credit",
        "total_due": "Total due"
      },
      "comparison": {
        "title": "Google Cloud AI translation\nvs Linguise AI translation",
        "list": {
          "0": {
            "google": "Fast and reliable translations",
            "linguise": "Handle idiomatic and technical expressions"
          },
          "1": {
            "google": "Instant translations of all the website pages",
            "linguise": "Generation of the translations in the background"
          },
          "2": {
            "google": "Best quality, low price",
            "linguise": "Perfect quality, affordable price"
          },
          "3": {
            "google": "Best fit for large websites or low budget",
            "linguise": "Best for the website requiring perfect translation quality"
          },
          "4": {
            "google": "Page context for translation",
            "linguise": "Page and website context for translation"
          }
        }
      },
      "botom_banner": {
        "title": "Experience Unmatched Translation Accuracy with the",
        "sub_title": "New Linguise AI Translation",
        "description": "Linguise is enhancing its automatic translation services with the introduction of Linguise AI Translation, a powerful new option utilizing cutting-edge AI translation LLM (most recent Llama models optimized for translations). This addition provides website developers and web agencies with an even higher tier of translation quality, ideal for projects where perfection is paramount. Linguise AI Translation complements our existing, high-quality Google Cloud AI translation, offering you greater flexibility and precision."
      }
    },
    "success": {
      "tab_title": "Thanks for buying AI Translation plan!",
      "title": "Thanks for buying AI Translation plan!",
      "subtitle": "Your AI Translation plan has been successfully bought!",
      "message": "You can manage your AI Translation plan in the AI Translation settings page.",
      "home": "Manage AI Translation"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Name",
        "description": "Billing account name"
      },
      "phone": {
        "title": "Phone",
        "description": "Billing account phone"
      },
      "email": {
        "title": "Email",
        "description": "Billing account email"
      },
      "address": {
        "title": "Address",
        "description": "Billing account address",
        "city": "City",
        "country": "Country",
        "address1": "Address 1",
        "address2": "Address 2",
        "postal": "Postal code",
        "state": "State"
      },
      "tax": {
        "title": "Tax number"
      }
    }
  },
  "checkouts": {
    "header": "Checkout",
    "payment_method": "Select Payment Method",
    "stripe_card": "Credit card (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "Enter new billing address",
      "existing": "Use existing address"
    },
    "pay_stripe": "Confirm and pay",
    "terms": "By confirming your subscription, you allow Linguise to charge you for future payments in accordance with our terms. You can always cancel your subscription.",
    "coupon": {
      "title": "Have a coupon?",
      "placeholder": "Insert your coupon code here",
      "apply": "Apply",
      "percent": "{{0}}% off"
    },
    "add_new": "Add new",
    "use_existing": "Use existing payment method",
    "recurring": {
      "month_single": "Billed monthly",
      "month_many": "Billed every {{count}} months",
      "year_single": "Billed yearly",
      "year_many": "Billed every {{count}} years",
      "day_single": "Billed daily",
      "day_many": "Billed every {{count}} days",
      "week_single": "Billed weekly",
      "week_many": "Billed every {{count}} weeks"
    },
    "add_new_no_stripe": "Add new card",
    "summary": {
      "title": "Summary",
      "subtotal": "Subtotal",
      "total": "Total"
    }
  },
  "dashboard": {
    "main": {
      "title": "Dashboard"
    },
    "statistics": {
      "main_title": "Last 30 days statistics",
      "characters": "Translated characters",
      "words": "Translated words",
      "bandwidth": "Input bandwidth",
      "request": "Requests",
      "page_views": "Pages views per language (last 30 days)",
      "multilingual_views": "Multilingual page views (last 30 days)",
      "most_page_viewed": "20 Most viewed pages (last 30 days)",
      "no_data_yet": "No data available yet",
      "th_language": "Language",
      "th_page_views": "Page views",
      "real_visitors": "Real Visitors",
      "crawler": "Crawler"
    },
    "planHints": {
      "subscribeButton": "Subscribe",
      "upgradeButton": "Upgrade",
      "usedWords": "You are currently {words_used} words",
      "noPlan": "No plan activated for this domain. Subscribe to a plan and start translating your website",
      "noPlanShopify": "No plan activated for this domain. Subscribe to a plan in your Shopify dashboard and start translating your website",
      "trialUsage": "You are currently using {words_used} words of the {words_allowed} words included in the trial plan.",
      "trialEnds": "The 1st month trial is activated until the {trial_ends}.",
      "subscribeMessage": "Subscribe before it finished to keep your website translated",
      "subscribeMessageShopify": "Subscribe from your Shopify dashboard before it finished to keep your website translated",
      "trialReachedLimit": "You have reached the maximum translated words for the trial period.\nSubscribe to one of our plans to continue translating your website.",
      "paidUsage": "You have used {words_used} / {words_allowed} translated words in your plan.",
      "paidReachedLimit": "You have reached the maximum translated words for the current plan.\nUpgrade your plan to continue translating your website content.",
      "trialOfferedUsage": "You are currently using {words_used} words of the {words_allowed} words included in the trial plan.(Including the {free_words} offered words)",
      "paidOfferedUsage": "You have used {words_used} / {words_allowed} translated words in your plan.(Including the {free_words} offered words)",
      "noPlanExtra": "Please note that inactive domains and their data are automatically deleted regularly.",
      "planRecommended": "Based on your current translation volume, the plan recommended is:",
      "planMaximumWords": "{{words}} words",
      "notHaveTranslatedWords": "You don't have made any translation yet"
    },
    "translationSetup": {
      "kicker": "SUBDOMAIN SETUP",
      "title": "Check translation setup",
      "description": "Review DNS, translated hosts, origin access and account limits.",
      "starting": "Checking...",
      "button": "Check setup",
      "viewLatest": "View latest result",
      "viewCurrent": "View current check",
      "runAgain": "Run check again",
      "viewDetails": "View details",
      "hideDetails": "Hide details",
      "error": "Unable to check setup",
      "allPassed": "All checks passed",
      "setupNeedsAttention": "Setup needs attention",
      "setupNeedsAttentionDescription": "One or more checks failed. Review the items below or contact Linguise support.",
      "lastChecked": "Last checked {{time}}",
      "domainOwnership": "Domain ownership",
      "domainOwnershipDescription": "Verification record found",
      "domainOwnershipFailure": "The DNS ownership record could not be verified.",
      "translatedHosts": "Translated hosts",
      "translatedHostsDescription": "{{count}} language hosts checked",
      "translatedHostsFailure": "One or more language CNAME records are incorrect.",
      "subdomainPage": "Subdomain page",
      "subdomainPageDescription": "{{count}} translated pages accept HTTPS",
      "subdomainPageFailure": "TLS connection failed while opening one or more translated pages.",
      "originalSite": "Original site",
      "originalSiteDescription": "Original DNS, TLS, and response checks",
      "originalSiteFailure": "The original site DNS, TLS, or response check failed.",
      "documentationAdvice": {
        "dns": "Review DNS setup",
        "tls": "Review HTTPS setup",
        "origin": "Review original site setup",
        "diagnostic": "Review troubleshooting steps"
      },
      "evidence": {
        "originDns": "Original DNS",
        "originTls": "Original TLS",
        "originHttp": "Original response",
        "observedTargets": "Observed targets",
        "recordCount": "Records found",
        "addressCount": "Addresses found",
        "statusCode": "HTTP status",
        "redirect": "Redirect",
        "expiresAt": "Certificate expires",
        "raw": "{{key}}",
        "noValue": "No value"
      },
      "checkerError": "Some checks could not be completed.",
      "coreLocation": "Checked from {{location}}",
      "status": {
        "queued": "Queued",
        "running": "Running",
        "completed": "Completed",
        "failed": "Failed",
        "passed": "Passed",
        "warning": "Warning",
        "unknown": "Unknown",
        "skipped": "Skipped",
        "not_applicable": "Not applicable"
      }
    },
    "throttling": {
      "title": "Translation throttle",
      "description": "Temporary usage limits",
      "unavailable": "Temporary translation limits unavailable",
      "window": "{{used}} / {{max}} words",
      "resetsIn": "Resets in {{time}}",
      "throttled": "Translation temporarily paused",
      "throttledDescription": "A temporary usage limit has been reached. Translation resumes when this window resets."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "STEP {{step}} OUT OF {{total}}",
      "doneLabel": "DONE, YOU CAN START TRANSLATING!",
      "finish": {
        "title": "",
        "description": "This is the API key to use on your website"
      },
      "instructions": "Installation instruction",
      "domainSetting": "Domain setting",
      "step": {
        "titleWordpress": "Wordpress",
        "titleJoomla": "Joomla",
        "titlePHP": "Script PHP",
        "wizardWordpressStep1": "1. Install the ",
        "wizardWordpressStep2": "\n 2. In the plugin settings copy and fill your API key\n",
        "wizardWordpressStep3": "3. You're ready to translate\n\n",
        "wizardWordpressStep4": "For a more detailed instruction, please have a look to our documentation: ",
        "wizardJoomlaStep1": "1. Joomla package link: ",
        "wizardJoomlaStep2": "\n2. In the extension configuration settings copy and fill your API key",
        "wizardJoomlaStep3": "3. In the module configuration, set the languages you want to display, and insert your module where you need it.",
        "wizardJoomlaStep4": "\n 4. You're ready to translate\n\n",
        "wizardPhpStep1": "1. Download our php script and here ",
        "wizardPhpStep2": "\n2. Follow the installation instruction in our documentation page here ",
        "wizardPhpStep3": "\n3. Add the module to your pages.",
        "wizardPhpStep4": "\n Copy the following code and add it to the head of your html page it will display the switcher module automatically\n",
        "dispatchStep1": "We've successfully sent the required data to Linguise plugin, you can close the following window now.",
        "dispatchStep2": "In case the token is missing when you close this window, please copy the following token:",
        "dispatchStep3": "You can also copy this snippet to enable our flag switcher automatically",
        "wizardOtherStep1": "Follow the instructions below to install Linguise on your domain.\n",
        "wizardOtherStep2": "Copy the following code and add it to the head of your html page it will display the switcher module automatically.\n"
      },
      "trialAlreadyUsed": "Seems like you already used your free trial, so you need to get translation quota\nPlease do subscribe a plan or contact us if you need to extend your trial.",
      "usefulLinks": "Useful links to get started",
      "linkDocumentation": "Documentation",
      "linkExtensionDl": "Extension download",
      "linkSubscribe": "Subscribe a plan now",
      "linkDashboard": "Go to the dashboard",
      "exclusion": {
        "title": "Company and products names",
        "description": ""
      },
      "finishButton": "Finish the setup",
      "subdomains": "Subdomains",
      "subdomain_setup": "Setup domain",
      "subdomain_auto_setup": "Connect your DNS automatically",
      "subdomain_manual_setup": "Add DNS entries myself",
      "subdomain_skip": "Do it later",
      "auto_subdomains_info": "Your site builder CMS requires a DNS configuration to set languages per subdomain (ex. es.domain.com).",
      "auto_subdomains_info_2": "You can do that automatically using Entri. Just click the \"Connect your DNS automatically\" button to start connecting to your DNS manager and add them with Entri.",
      "auto_subdomains_info_manual": "Or, you can manually configure your domain by clicking \"Add DNS entries myself\" button.",
      "breadcrumbs": {
        "step1": "Step 1: Domain, CMS & Languages",
        "step2": "Step 2: Language DNS",
        "step3": "Step {{step}}: Installation instructions"
      }
    },
    "form": {
      "urls": {
        "dash": "Dash -",
        "underscore": "Underscore _",
        "title": "Translate URLs",
        "description": "Do you want to translate in all pages",
        "char_description": "Character to use to replace non authorized characters in URLs",
        "advertisement_title": "⚠ You have set a lot of languages.\n",
        "advertisement": "We usually advise to start translating websites with few languages at first. You will have an idea about how many words your website has. It's also better for SEO, as Google bots will crawl more quickly all your pages if you have fewer pages at first. After a week you can add a few more languages and so on."
      },
      "language_removal": {
        "card": {
          "title": "Delete translations of removed languages",
          "description": "These languages were removed from your website, but their stored translations still count against your quota. Delete them to get the words back.",
          "button": "Delete translations"
        },
        "hint": "This gives the words they used back to your quota. You can do this once every {{days}} days for each website.",
        "modal": {
          "title": "Delete translations?",
          "intro": "These translations will be permanently deleted:",
          "warning": "This cannot be undone. The words they used are returned to your quota, which can take a few minutes.",
          "limit": "You can do this once every {{days}} days for each website.",
          "confirm": "Delete translations"
        },
        "scheduled": "The translations are being deleted and your quota will be updated shortly.",
        "cooldown": "Translations for this website were deleted recently. You can delete translations again on {{date}}.",
        "latest_completed": {
          "title": "Latest completed deletion",
          "description": "Review the languages deleted and words returned to your quota.",
          "languages": "Languages deleted",
          "words_returned": "Words returned to your quota: {{words}}",
          "completed_at": "Completed {{date}}"
        },
        "status": {
          "recent_title": "Recent translation deletion",
          "recent_description": "Track the latest deletion and see when another deletion is available.",
          "progress_title": "Deletion progress",
          "loading": "Checking deletion progress...",
          "unavailable": "Could not load deletion progress. Refresh this page to try again.",
          "label": "Status",
          "pending": "Queued",
          "processing": "In progress",
          "completed": "Completed",
          "failed": "Failed",
          "unknown": "Status unavailable",
          "percent": "{{percent}}% complete",
          "current_stage": "Current step: {{stage}}",
          "processed": "{{processed}} records processed",
          "processed_total": "{{processed}} of {{total}} records processed",
          "requested_at": "Requested {{date}}",
          "started_at": "Started {{date}}",
          "completed_at": "Completed {{date}}",
          "cooldown_period": "You can delete translations once every {{days}} days for each website.",
          "cooldown_blocked": "Another deletion cannot be started yet.",
          "stage": {
            "queued": "Waiting to start",
            "processing": "Processing",
            "refund_summary": "Calculating returned words",
            "search_translations": "Deleting search translations",
            "url_translations": "Deleting URL translations",
            "translations": "Deleting translations",
            "completed": "Completed",
            "failed": "Failed",
            "unknown": "Processing"
          }
        },
        "forbidden": "You do not have permission to delete translations."
      },
      "url": {
        "title": "Url",
        "description": "Put your main domain URL starting with http:// or https://",
        "placeholder": "Domain URL",
        "advertisement_http": {
          "title": "You're not using the https protocol",
          "description": "Please check that your domain is actually not using the https protocol, which is nowadays recommended."
        },
        "advertisement_www": {
          "title": "Your subdomain is not www",
          "description": "Most of the time the default subdomain is www (like https://www.mydomain.com). This may not be your case but please double check the domain you want to add is the correct one."
        },
        "invalid_url": {
          "line1": "We have not been able to find your domain. Please check that your domain is publicly accessible via the Internet and it's not redirected to another location.",
          "line2": "If you are sure your domain is accessible, you can skip domain verification and press \"Next step\" button again",
          "contact": "In any case you can contact us at",
          "force": "Skip domain verification"
        },
        "invalid_subdomain_url": "This url is not allowed.\nSubdomains must be in the form of: https://www.domain.tld or https://domain.tld without subdirectory"
      },
      "account": {
        "title": "Account",
        "description": "Select an account to assign this domain",
        "placeholder": "Select account...",
        "feedback": "You must choose an account"
      },
      "platform": {
        "title": "Platform",
        "description": "Please select your website platform by CMS name.",
        "learn": "Learn how to choose it",
        "placeholder": "Search platform by CMS name...",
        "info": {
          "title": "⚠ This platform has been added recently.\n",
          "desc": "This website builder platform is supported by Linguise, although it has been added recently. If you experience any issue, please contact us using the direct support email:"
        },
        "description_read_only": "The platform your website is using",
        "feedback": "You must choose a platform"
      },
      "language": {
        "title": "Language",
        "description": "Select the base language of your website",
        "placeholder": "Select language...",
        "feedback": "You must choose a language",
        "description_read_only": "Base language of your website"
      },
      "token": {
        "title": "API Key",
        "description": "This is the API Key to copy to your website",
        "copy": "Copy to clipboard",
        "reset": "Reset API Key",
        "reset_confirm": "Please confirm API Key reset"
      },
      "languages": {
        "title": "Translation languages",
        "description": "Select the languages you want your website to be translatable into",
        "placeholder": "Select languages...",
        "feedback": "You must choose a language"
      },
      "defaultRules": {
        "title": "Default rules",
        "description": "We have defined a set of must use rules to enhance translation and avoid unwanted content to be translated, like the WordPress dashboard.\nYou can remove or edit theses rules later if you wish."
      },
      "disallow_deletion": "You cannot delete domain with active subscription",
      "ai_disallow_deletion": "You cannot delete this domain while an AI quota is still available.\nPlease contact our support team if you, want to delete this domain at",
      "delete_confirm": "Please confirm domain deletion",
      "delete": "Delete domain",
      "dynamic": {
        "title": "Translate Dynamic Content",
        "description": "Dynamic content generated by JavaScript and AJAX request will be translated (This option will increase your translation usages)"
      },
      "partial_translations": {
        "title": "Allow Partial Translation",
        "description": "If your account has reached its translation quota but the page still requires translation, Linguise can continue displaying the page with the content that has already been translated.\nHowever, some parts of the page will remain untranslated until you upgrade your quota.\n\nWhile a small amount of untranslated content usually won’t harm SEO, allowing too much untranslated content could negatively impact the user experience.\nTo address this, you can set a threshold for the percentage of untranslated content allowed on a page. If the untranslated content exceeds this threshold, users will automatically be redirected to the original language version of the page.",
        "never": "Never"
      },
      "translate_error_pages": {
        "title": "Translate error pages",
        "description": "Linguise can translate all error pages, however if your error page contains dynamic content, like IP address or requests ID, you should avoid translating these pages.",
        "not_found_page": {
          "title": "Translate 404 page"
        },
        "error_page": {
          "title": "Translate other error pages"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Existing domain found",
          "description": "An existing domain has been found for this user, do you want to use it?"
        }
      },
      "search_tl": {
        "title": "Search Translations",
        "description": "Enable search translations for your website platform (Experimental, this option will increase your translation usages)"
      },
      "shopify_promo": {
        "info": "Good news! We now have a Shopify native app that you can install from Shopify App Store",
        "hyperlink": "Click here and do the Linguise installation from the app.",
        "next_btn": "Go to Shopify store to install the app",
        "info_legacy": "Good news! We now have a Shopify native app that you can install from Shopify App Store",
        "description_legacy": "Select the \"Shopify\" platform instead of \"Shopify Legacy\""
      },
      "wix_promo": {
        "info": "Good news! We now have a Wix native app that you can install from Wix App Market",
        "hyperlink": "Click here and do the Linguise installation from the app.",
        "next_btn": "Go to Wix App Market to install the app",
        "info_legacy": "Good news! We now have a Wix native app that you can install from Wix App Market",
        "description_legacy": "Select the \"Wix\" platform instead of \"Wix Legacy\""
      }
    },
    "main": {
      "edit": "Edit domain",
      "add": "Add domain",
      "wizard": "Welcome! New domain creation wizard",
      "common": "Domain"
    },
    "notice": {
      "broken_card": "We were unable to renew your plan for {{url}} using the current payment method, please update your payment card",
      "quota_warning": "Your translation quota for {{url}} has reach {{throttling_used_percent}}%, this would reset in {{ttl}}",
      "quota_reached": "Your translation quota for {{url}} has been reached, please upgrade to resume your website translation",
      "ai_no_subscription": "AI translation for {{url}} requires an active subscription or active trial. It will stop without one, please upgrade to continue",
      "important": "Important",
      "quota_reached_button": "Upgrade your plan now",
      "broken_card_button": "Update your payment card",
      "ai_no_subscription_button": "Upgrade your plan now",
      "locked": "The domain {{url}} is currently locked for migration, you can still access your site but unable to edit or add new translations!"
    },
    "subdomains": {
      "config_ok": "Subdomains DNS has been configured properly.",
      "config_invalid": "Subdomains DNS requires some extra-configuration to work.",
      "config_check": "Subdomains DNS configuration is being checked, please wait...",
      "entri_timeout": "Entri reported that your Subdomains DNS propagation process has timed out, you would need to retry again or you can do it manually.",
      "entri_process": "Your DNS have been added with Entri and it usually takes 10-30 minutes to propagate (apply all your languages subdomains like es.domain.com). If the DNS validation is not finished after 24 hours, you can reach our support team: support@linguise.com",
      "entri_ok": "DNS propagation is on its way! Waiting for propagation...",
      "infos": "You must add these DNS entries to your DNS domain records to activate the translation. Click the check button when it has been done.\nIt is possible that DNS records may take some time to propagate, so you may need to return after a few minutes or hours.",
      "check": "Check DNS configuration"
    },
    "subscription": {
      "next_payment_amount": "Upcoming charges",
      "next_payment_date": "Next payment date",
      "invoice": {
        "header": "Invoice history",
        "date": "Date",
        "amount_due": "Amount",
        "status": "Status",
        "actions": "Actions",
        "description": "Once transactions are available, you can view them here.",
        "status_text": {
          "draft": "Draft",
          "failed": "Failed",
          "open": "Pending",
          "paid": "Paid",
          "retrying": "Retrying",
          "uncollectible": "Uncollectible",
          "void": "Void"
        },
        "view": "View",
        "empty": "There is no recent invoices found for this subscription",
        "retry_payment": "Retry"
      },
      "next_cancellation": "Cancellation date",
      "cancel": "Cancel subscription",
      "change_plan": "Change plan",
      "unknown_plan": "Unknown plan",
      "change": "Change",
      "suspend": "Suspend payment",
      "resume": "Resume subscription",
      "back": "Back",
      "save": "Save",
      "confirm_resume": "Are you sure you want to resume this subscription?",
      "confirm_cancel": "Are you sure you want to cancel this subscription?",
      "confirm_header": "Are you sure?",
      "missing_status": "This subscription is missing",

      "not_found": "No subscription found for this domain",
      "confirm_manual_retry": "Are you sure you want to retry this payment?",
      "no_payment_method": "Unknown",
      "remove_billing": "Remove",
      "shopify_maneged": "This subscription is managed by Shopify. Please manage it from your Shopify admin panel."
    }
  },
  "domain_listing": {
    "add": "Add website",
    "select": "Choose a domain"
  },
  "editable": {
    "number": "number {{id}}"
  },
  "footer": {
    "about": "About",
    "support": "Support"
  },
  "frontendEditor": {
    "main": "Live Editor",
    "description": "The Live Editor helps you to directly edit the translations in your website.",
    "button": "Open Live Editor",
    "language_selection": "Translation language selection",
    "video_label": "Learn how to use the live editor"
  },
  "general": {
    "403": {
      "tab_title": "Ooops - 403 Error",
      "title": "Access denied",
      "message": "Looks like you don't have access to the requested page.",
      "home": "Return Home"
    },
    "404": {
      "tab_title": "Ooops - 404 Error",
      "title": "Page Not Found",
      "message": "It looks like you may have taken a wrong turn. Don't worry... it happens to the best of us. Here's a little tip that might help you get back on track.",
      "home": "Return Home"
    },
    "500": {
      "tab_title": "500 Error",
      "title": "Internal Server Error",
      "message": "Why not try refreshing your page? or you can contact us",
      "home": "Return Home"
    },
    "fields": {
      "alert": "Some fields are not valid, please correct the invalid fields.",
      "invalid": "This field is invalid",
      "phone_re": "Phone number is invalid",
      "phone_invalid": "Phone number is invalid",
      "email": "Email field is invalid"
    },
    "table": {
      "no_data": "There's no data here yet..."
    },
    "saving": "Saving ...",
    "save": "Save",
    "save_and_quit": "Save & Quit",
    "invite": "Invite",
    "cancel": "Cancel",
    "yes": "Yes",
    "no": "No",
    "nextStep": "Next step",
    "loading": "Please wait will the application is loading",
    "goback": "Go back",
    "manage": "Manage",
    "delete": "Delete",
    "deleting": "Deleting ...",
    "confirm": "Confirm",
    "unknown": "Unknown",
    "hide": "Hide",
    "show": "Show",
    "on": "On",
    "off": "Off",
    "default": "Default"
  },
  "home": {
    "header": "Home",
    "manage": "Manage subscription",
    "canceled": "Scheduled for cancellation",
    "activate_now": "Activate now",
    "activate_plan_now": "Subscribe now",
    "upgrade_plan_now": "Upgrade plan now",
    "trial_message_part_1": "You're currently on the trial plan, ",
    "trial_message_part_2": "you can activate a membership anytime.",
    "add": "Add domain",
    "table": {
      "title": "Domains",
      "description": "List of your domains, click on the domain to manage translations"
    },
    "domains": {
      "empty": "You don't have any domains at this account"
    },
    "accountsList": {
      "title": "Accounts",
      "add": "Add new account",
      "name": "Account name"
    },
    "update_credit_card": "Update credit card details",
    "cancelling_subs": "Cancelling at {{0}}",
    "resume_subscription": "Resume subscription",
    "shopify_managed": "Managed by Shopify",
    "trial_ends_at": "Ends at {{0}}",
    "free_trial": "Free trial",
    "no_subs": "No active subscription"
  },
  "invoices": {
    "title": "Invoices",
    "list": {
      "title": "Invoices list"
    },
    "table": {
      "customer": "Customer",
      "domain": "Domain",
      "amountPaid": "Amount Paid",
      "status": "Status",
      "date": "Date",
      "invoice": "Invoice",
      "pay": "Pay invoice",
      "actions": "Actions",
      "deleted_domain": "Domain deleted",
      "plan_name": "Plan",
      "action": "Action"
    },
    "listPending": {
      "title": "Pending invoices list"
    }
  },
  "language_settings": {
    "display": "Language list display",
    "position": "Position",
    "display_help_text": "Display flag and/or language names. Language switcher default position could be anywhere in the content or in a fixed position that stays fixed or moves on scroll",
    "side_by_side": "Side by side",
    "dropdown": "Dropdown",
    "popup": "Popup",
    "flag": "Flag",
    "lang_name": "Language name",
    "lang_short_name": "Short names",
    "positions": {
      "in_place": "In place",
      "top_left": "Top left",
      "top_left_no_scroll": "Top left (no-scroll)",
      "top_right": "Top right",
      "top_right_no_scroll": " Top right (no-scroll)",
      "bottom_left": "Bottom left",
      "bottom_left_no_scroll": "Bottom left (no-scroll)",
      "bottom_right": "Bottom right",
      "bottom_right_no_scroll": "Bottom right (no-scroll)"
    },
    "lang_names_display": {
      "title": "Language names display",
      "help_text": "In the language switcher, display the language names in English or in the original language, i.e. French or Français",
      "english": "English",
      "native_languages": "Native Languages"
    },
    "flag_shape": {
      "title": "Flag style",
      "help_text": "Use round svg or rectangular svg flag icons",
      "round": "Round",
      "rectangular": "Rectangular"
    },
    "english_flag_type": {
      "title": "English flag type",
      "help_text": "Use the Great Britain or USA Flag for english",
      "usa": "USA flag",
      "great_britain": "Great Britain flag"
    },
    "german_flag_type": {
      "title": "German flag type",
      "help_text": "Use the Austria or German Flag for german",
      "german": "German flag",
      "austria": "Austria flag"
    },
    "spain_flag_type": {
      "title": "Spanish flag type",
      "help_text": "Use the Mexico or Spanish Flag for spanish",
      "spanish": "Spanish Flag",
      "mexico": "Mexico Flag",
      "peruvian": "Peruvian Flag"
    },
    "portugal_flag_type": {
      "title": "Portuguese flag type",
      "help_text": "Use the Portuguese or Brazilian Flag for Portuguese",
      "portugal": "Portuguese Flag",
      "brazil": "Brazilian Flag"
    },
    "taiwanese_flag_type": {
      "title": "Taiwanese flag type",
      "help_text": "Use the Taiwanese or Chinese Flag for Taiwanese",
      "taiwanese": "Taiwanese Flag",
      "chinese": "Chinese Flag"
    },
    "flag_border_radius": {
      "title": "Flag border radius (px)",
      "help_text": "If you're using the rectangle flag shape you can apply a custom border radius in pixels"
    },
    "flag_width": {
      "title": "Flag size (px)",
      "help_text": "Select flags size in pixels. That doesn't change the image weight as it's a .svg format"
    },
    "lang_color": {
      "color_title": "Language name color",
      "color_help_text": "Select a default text color for your language names",
      "hover_color_title": "Language name hover color",
      "hover_color_help_text": "Select a mouse hover text color for your language names",
      "color_popup_title": "Popup language color",
      "color_popup_help_text": "Color of the language title in the popup or in the dropdown areas",
      "hover_color_popup_title": "Popup language hover color",
      "hover_color_popup_help_text": "Select a mouse hover text color of the language title in the popup or in the dropdown areas"
    },
    "flag_box_shadow": {
      "shadow_title": "Flag box shadow",
      "shadow_help_text": "Color and shadow size for your language flags",
      "hover_shadow_title": "Flag box shadow on hover",
      "hover_shadow_help_text": "Color and shadow size for your language flags on mouse hover",
      "shadow_h_offset": "Shadow H offset (px)",
      "shadow_v_offset": "Shadow V offset (px)",
      "shadow_blur": "Shadow blur (px)",
      "shadow_spread": "Shadow spread (px)",
      "shadow_color": "Shadow color"
    },
    "order": "Language order",
    "language_order_help": "The order of the language that will be shown in the language switcher. You can drag and drop the language to reorder them.",
    "order_reset": "Reset order",
    "language_order_dragdrop": "You can drag and drop the language to reorder them.",
    "popup_lang_name": "Popup Language Name",
    "preview": "Language preview"
  },
  "link": {
    "form": {
      "original": {
        "title": "Original Source",
        "description": "Add your original link URL and replace it below by language to translate them",
        "srcset_description": "You're editing an image url. Please make sure to read the documentation, especially if you use srcset, or don't know what it is",
        "link": "Link",
        "match_link": "Match mode",
        "match_exact": "Exact",
        "match_wildcard": "Wildcard",
        "match_regex": "Regex"
      },
      "alternative_languages": {
        "title": "Links to replace",
        "description": "Replace media links and external links all over your pages, by language…",
        "link": "Link to replace"
      },
      "error": {
        "atLeastOne": "Please at least add one translation.",
        "url": "The url is invalid",
        "extension": "The link should have an extension, but it cannot be .html or .php. And the link should not contain any language path e.g. \"/fr\"",
        "regex": "The regex is invalid",
        "wildcard": "The wildcard link has an invalid protocol"
      }
    },
    "main": {
      "parent": "Links",
      "edit": "Edit link"
    }
  },
  "links": {
    "title": "Media and external links management",
    "description": "List and edit your website Media links or external links.",
    "add": "Add Link",
    "delete": "Delete Link",
    "table": {
      "original": "Original",
      "language": "Language",
      "translation": "Translation",
      "action": "Action",
      "delete_confirm": "Please confirm link deletion"
    }
  },
  "members": {
    "header": "Members",
    "invite": "Invite a new member",
    "modal": {
      "inviteHeader": "Invite a new member",
      "editHeader": "Edit member",
      "detachHeader": "Detach member",
      "detachBody": "Are you sure you want to detach member from this account?",
      "selfDetachBody": "Are you sure that you want to detach yourself from this account management? After that, you won't be able to access any of the data related to this account."
    },
    "table": {
      "title": "Members list",
      "description": "Members roles and domains access",
      "name": "Name",
      "email": "Email",
      "websites": "Websites",
      "languages": "Languages",
      "role": "Role",
      "status": "Status",
      "resendInvite": "resend",
      "inviteSent": "invite was sent",
      "actions": "Actions",
      "edit": "Edit",
      "detach": "Detach",
      "empty": "You don't have any members yet",
      "all_website": "All websites and languages",
      "roles": {
        "admin": "Admin",
        "manager": "Manager",
        "translator": "Translator"
      },
      "statuses": {
        "pending": "Pending",
        "accepted": "Accepted",
        "declined": "Declined"
      }
    },
    "errors": {
      "role": "You must choose a role",
      "domains": "You must choose at least 1 website for selected role",
      "languages": "You must choose at least 1 language for selected websites"
    },
    "inviteSent": "Your invitation has been successfully sent"
  },
  "pagination": {
    "showing": "Showing {{limit}} of {{total}} results",
    "showing_only_count": "Showing {{limit}} results"
  },
  "payments_method": {
    "header": "Payment Methods",
    "table": {
      "title": "Payment methods list",
      "description": "Attached payment methods to your account",
      "default": "Default",
      "action_edit_remove": "Edit or remove",
      "action_remove": "Remove",
      "action_default": "Set as default",
      "action_fallback": "Set as fallback",
      "expires": "Expires",
      "add_new_card": "Add payment method",
      "action_fallback_remove": "Remove from fallback",
      "fallback": "Fallback",
      "action_edit": "Edit",
      "action_delete": "Delete",
      "action_default_remove": "Remove as Default",
      "domain_count@@one": "Used by {{count}} domain",
      "domain_count@@other": "Used by {{count}} domains"
    },
    "paypal_bind": {
      "button": "Connect PayPal Account",
      "button_load": "Connecting...",
      "disconnected": "Not connected",
      "success": "Your PayPal account is now connected, a $5 will be deduced from your next invoice!",
      "success_no_promo": "Your PayPal account is now connected",
      "error": "An error has occured",
      "success_header": "Success"
    },
    "card_add": {
      "header": "Add new card",
      "success": "Connected new card to Linguise!",
      "terms": "By providing your card information, you allow Linguise to charge your card for future payments according to our terms of service."
    },
    "card_detail": {
      "header": "Card info",
      "delete": {
        "error": "You cannot delete this payment method because it have an active subscriptions!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Subscriptions on this payment method",
        "header_domain": "Domain",
        "header_plan": "Plan",
        "header_status": "Status",
        "header_actions": "Actions",
        "cancelling": "Cancelling at: {{0}}",
        "next_payment": "Next payment at: {{0}}",
        "action_renew": "Renew",
        "no_subs_header": "No subscriptions to show",
        "no_subs_desc": "Once a subscription is made to this card, all information will be displayed here",
        "action_manage": "Manage"
      },
      "status": {
        "active": "Active",
        "canceled": "Canceled",
        "incomplete": "Unpaid",
        "incomplete_expired": "Unpaid (Expired)",
        "missing": "Error",
        "past_due": "Past due",
        "trialing": "Trial",
        "unpaid": "Unpaid"
      }
    },
    "delete_confirm_body": "Are you sure you want to delete this payment method? This action cannot be reversed!",
    "delete_confirm_header": "Delete payment method?",
    "card_edit": {
      "header": "Edit card",
      "billing_header": "Billing information",
      "address_error": "Address is required!",
      "card_number": "Card number",
      "card_expiry": "Expiration date",
      "expiry_error_month": "Invalid month provided",
      "expiry_error_year": "Invalid year provided",
      "expiry_error_expired": "Your card's expiration year is in the past.",
      "card_header": "Card information",
      "expiry_error_empty": "This field is required!"
    }
  },
  "plans": {
    "per": "per",
    "wordsTranslated": "words translated",
    "current": "Current",
    "archived": "Archived",
    "day": "day",
    "week": "week",
    "month": "month",
    "year": "year",
    "activate": "Activate",
    "cancel": "Cancel",
    "change": "Change",
    "upgrade": "Upgrade",
    "downgrade": "Downgrade",
    "resume": "Resume",
    "notEnoughWords": "Not enough words",
    "yearIntervalOnly": "Can't migrate from yearly plan",
    "subsCanceled": "There is another subscription cancelation in progress",
    "wordsUnlimited": "Unlimited words",
    "tabs": {
      "day": "Daily prices",
      "week": "Weekly prices",
      "month": "Monthly prices",
      "year": "Yearly prices",
      "sub_texts": {
        "day": "One fixed price, every day",
        "week": "One fixed price, every week",
        "month": "One fixed price, every month",
        "year": "One month free, one bill per year"
      }
    },
    "details": {
      "new_languages": "Add new languages at any time",
      "one_month_trial": "One-month free trial for every new website",
      "multi_content_indexed": "100% of multilingual content indexed",
      "translate_new_content": "Translate new content instantly",
      "free_installation": "Free installation and setup",
      "compared_monthly_plan": "One month free compared to monthly plans",
      "risk_free_recurring": "Risk-free recurring payment failure",
      "unlimited_languages": "Unlimited languages & page views",
      "high_server_resources": "High server resources",
      "billed": {
        "day": "Billed daily",
        "week": "Billed weekly",
        "month": "Billed monthly",
        "year": "Billed yearly"
      },
      "request_max_size": "{{0}} request max size"
    },
    "frequent_question": {
      "title": "Frequent questions",
      "questions": {
        "trial": {
          "question": "Can I use the trial on a new website domain?",
          "answer": "Yes, we do offer a 30-day free trial for every new website domain you add to your account. This way, you can fully test the translation service on your new website."
        },
        "seo": {
          "question": "How much time does it take for my SEO to improve?",
          "answer": "Content, and multilingual content take time to be fully indexed and well ranked. Depending on your website traffic and size, it's between 3 and 6 weeks."
        },
        "quota": {
          "question": "Are the human translations included in quota?",
          "answer": "Nope, the word count limit is only for automatic machine translations. A translator can manually edit automatic translations with no limit."
        }
      }
    },
    "best_offer": "Best offer",
    "period": {
      "days@@one": "day",
      "days@@other": "{{count}} days",
      "hours@@one": "hour",
      "hours@@other": "{{count}} hours",
      "minutes@@one": "minute",
      "minutes@@other": "{{count}} minutes",
      "seconds@@one": "second",
      "seconds@@other": "{{count}} seconds"
    },
    "words": {
      "billion": "{{value}}B",
      "million": "{{value}}M",
      "thousand": "{{value}}K"
    },
    "throttling_info": "{{words}} words per {{period}}"
  },
  "profile": {
    "welcome": "Welcome!",
    "account": "My Account",
    "subscriptions": "Subscriptions",
    "logout": "Logout"
  },
  "register": {
    "errors": {
      "password": "Minimum 8 characters, any character"
    }
  },
  "route": {
    "dashboard": "Dashboard",
    "rules": "Rules",
    "translations": "Translations",
    "search_translations": "Search Queries",
    "urls_translations": "Urls Translations",
    "links": "Media and external links",
    "online_editor": "Live Editor",
    "settings": "Settings",
    "domain": {
      "finish": "Settings",
      "preconfig": "Settings"
    },
    "home": "Home",
    "domain_list": "Domain list",
    "members": "Members",
    "invoices": "Invoices",
    "billing": "Billing details",
    "language_display": "Language flags display",
    "payment_methods": "Payment Methods",
    "ai_translation": "AI Translation",
    "ai_translation_settings": "Settings",
    "ai_translation_pricing": "Pricing"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Text to ignore",
        "add": "Add new",
        "title": "Text to ignore",
        "description": "Add one or multiple texts to ignore",
        "ignore_case": "Ignore case"
      },
      "html_content": {
        "title": "Apply to html content",
        "description": "Apply rule all over your content or by selecting a specific CSS selector",
        "all_page": "All page",
        "css_selector": "CSS selector",
        "label": "CSS selector",
        "placeholder": "Selector to apply to",
        "add": "Add new"
      },
      "apply_to_urls": {
        "title": "Apply to URLs",
        "description": "Select specific URLs where you want the rule to apply",
        "all_urls": "All URLs",
        "selected_urls": "Selected URLs",
        "label": "Url to apply to",
        "placeholder": "Url to apply to",
        "original_url": "Original URLs",
        "translated_url": "Translated URL",
        "wildcard": "Wildcard",
        "regex": "Regular expression",
        "add": "Add new",
        "expression": "Expression type"
      },
      "apply_urls": {
        "title_exclude": "Exclude in URLs",
        "title_replace": "Replace in URLs",
        "title_description": "Also apply this rule to translation of URLs"
      },
      "apply_languages": {
        "title": "Apply to languages",
        "description": "Select specific language where you want the rule to apply",
        "all_languages": "All languages",
        "selected_languages": "Selected languages",
        "placeholder": "Select languages...",
        "feedback": "You must choose a language"
      },
      "name": {
        "title": "Title",
        "description": "Give your rule a title for convenience",
        "placeholder": "Rule name"
      },
      "type": {
        "title": "Type",
        "description": "Choose the type of rule you want to add",
        "text_ignore": "Text ignore",
        "text_replace": "Text replace",
        "content_exclusion": "Content exclusion",
        "url_exclusion": "Exclusion by URL",
        "ignore_inline": "Ignore inline",
        "full_description": {
          "text_ignore": "Add rules to avoid some text to be translated. It could be your product name, brand name or other technical elements that you don’t want to be translated.",
          "text_replace": "Text replace allows to replace some text by the translation you want, it may be necessary when the translation ignores the context.",
          "content_exclusion": "Content exclusion will help you to avoid the translation off some content in the page.\n If you want to completely exclude a page from translation (no multilingual URL at all for this page and no translated content) please use the \"Exclusion by URL\" type",
          "url_exclusion": "Page translation exclusion will help you to set the pages you do not want to translate.",
          "ignore_inline": "Avoid translating some content as inline content, translate each tag separately instead."
        }
      },
      "text_replace": {
        "title": "Text to replace",
        "description": "Replace some text by your specific translation. Replace any text all over your pages, by language…",
        "text_to_replace": "Text to replace",
        "ignore_case": "Ignore case",
        "text_type": "Replacement in translation",
        "text_type_original": "Original",
        "text_type_translation": "Translation",
        "keep_case": "Try to keep case",
        "add": "Add new"
      },
      "content_exclusion": {
        "title": "Content exclusion",
        "description": "Select one or more CSS selector which will not be translated",
        "label": "CSS selector",
        "placeholder": "Selector to apply to",
        "add": "Add new"
      },
      "multilingual_url": {
        "title": "Use multilingual URL",
        "description": "If set Yes, the URL will NOT be translated but the page will remain multilingual with a translated content",
        "live_example_title": "Live example",
        "live_example_description": "Source URL: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "Generated URL: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "Generated URL: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Apply the rule on static content or dynamic content or both",
        "title": "Apply to content",
        "all": "All content",
        "static": "Static content",
        "dynamic": "Dynamic content"
      },
      "force_apply_urls": {
        "title_description": "Force apply this rule to all translation of URLs, including existing translations!",
        "title_replace": "Force replace in URLs",
        "title_exclude": "Force exclude in URLs",
        "warning": "Warning",
        "warning_part1": "Setting this to \"Yes\" might break your website URL translations.",
        "warning_part2": "This can temporarily or permanently generate a 404s page, please only continue if you understand the consequences.",
        "warning_replacement_original": "Additional warning: You're trying to replace original content that might affects URL, the translation might fails since Linguise unable to find the original URLs properly"
      }
    },
    "main": {
      "parent": "Rules",
      "edit": "Edit rule",
      "add": "New rule"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "\"{{text_ignore}}\" will be ignored in the content and in the URL",
      "preview_single": "\"{{text_ignore}}\" will be ignored in the content",
      "preview_more_with_url": "\"{{text_ignore}}\" and {{count}} more will be ignored in the content",
      "preview_more": "\"{{text_ignore}}\" and {{count}} more will be ignored in the content",
      "other_parameters": "Other parameters are set for this rule, click the edit button to get more information"
    },
    "text_replace": {
      "preview_single_with_url": "\"{{original}}\" is replaced by \"{{replacement}}\" in the content and the URLs",
      "preview_single": "\"{{original}}\" is replaced by \"{{replacement}}\" in the content",
      "preview_more_with_url": "\"{{original}}\" is replaced by \"{{replacement}}\" in the content and the URLs, and {{nb}} more",
      "preview_more": "\"{{original}}\" is replaced by \"{{replacement}}\" in the content, and {{nb}} more",
      "other_parameters": "Other parameters are set for this rule, click the edit button to get more information"
    },
    "content_exclusion": {
      "selectors": "{{nb}} CSS selector(s) excluded from translation",
      "other_parameters": "Other parameters are set for this rule, click the edit button to get more information"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URLs are excluded from translation, but still keep the multilingual prefix",
      "some": "{{nb}} URLs are completely excluded from translation",
      "all_multilingual": "all URLs are excluded from translation, but still keep the multilingual prefix",
      "all": "all URLs are completely excluded from translation",
      "other_parameters": "Other parameters are set for this rule, click the edit button to get more information"
    },
    "ignore_inline": {
      "elements": "All inline content will be translated as blocks content in the page",
      "all_elements": "Some inline content will be translated as blocks content in the page",
      "other_parameters": "Other parameters are set for this rule, click the edit button to get more information"
    },
    "title": "Rules management",
    "description": "Manage your translations content exclusions and replacement all over your website",
    "add": "Add new rule",
    "table": {
      "title": "Title",
      "no_data": "No rules here yet",
      "type": "Type",
      "preview": "Rule preview",
      "action": "Action",
      "delete_confirm": "Please confirm rule deletion",
      "types": {
        "text_ignore": "Text ignore",
        "text_replace": "Text replace",
        "content_exclusion": "Content exclusion",
        "url_exclusion": "Url exclusion",
        "ignore_inline": "Ignore inline",
        "unknown": "Unknown rule"
      }
    },
    "apply_on_content": {
      "static": "This rule will only be applied on static content",
      "dynamic": "This rule will only be applied on dynamic content"
    }
  },
  "search_translations": {
    "title": "Search queries management",
    "description": "List all your website translation used through search forms (From translated language to your domain base language)",
    "filter_languages": "Filter by languages...",
    "filter_original": "Filter text in original language",
    "filter_translation": "Filter by translated text",
    "table": {
      "original": "Original",
      "language": "Language",
      "translation": "Translation"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Failed to subscribe!",
      "title": "Failed to subscribe!",
      "subtitle": "An error has occurred when trying to process your subscription.",
      "home": "Go back home",
      "generic": "An unknown error has occured on Linguise side, please contact administrator!"
    },
    "success": {
      "home": "Manage domain translations",
      "message": "We are committed to providing you with the best possible translation experience. Our team of experts is available to assist you with any questions or support you may need. To get started, simply click on the button below.",
      "subtitle": "Thank you for choosing Linguise translation service",
      "title": "Subscription activated!",
      "tab_title": "Thanks for subscription!"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "Subscription activated!",
      "title": "Subscription activated!",
      "subtitle": "Thank you for choosing Linguise translation service",
      "message": "'We are committed to providing you with the best possible translation experience. Our team of experts is available to assist you with any questions or support you may need. To get started, simply click on the button below. ",
      "home": "Manage domain translations"
    },
    "edit": {
      "title": "Manage subscription"
    },
    "list": {
      "title": "Subscriptions list",
      "description": "List of your domain subscriptions"
    },
    "table": {
      "domain": "Domain",
      "plan": "Plan",
      "status": "Status",
      "card": "Card",
      "usage": "Usage",
      "actions": "Actions",
      "payment_method": "Payment Method"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} words",
      "paidOffered": "{{words_used}} / {{words_allowed}} words\n(Included {{free_words}} offered words)"
    },
    "popup": {
      "nextPeriod": "Starting from {{date}}",
      "dueToday": "Total due today"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Choose an account"
    }
  },
  "translation": {
    "main": {
      "parent": "Translations",
      "edit": "Edit translation"
    },
    "form": {
      "original": {
        "title": "Original in {{language}}"
      },
      "is_inline": "This translation is made from inline content.",
      "inline_editor": {
        "count_warning": "The number of inline areas does not match the original ({{current}} of {{expected}}).",
        "restore_original": "Restore original text",
        "insert_placeholder": "Insert placeholder",
        "drag": "Drag to reorder inline area",
        "area": "Inline area {{index}}",
        "restore": "Restore missing inline areas"
      },
      "translation": {
        "title": "Translation in {{language}}",
        "description": "Translation you want to override"
      }
    },
    "copy": {
      "title": "Copy into the manual translation",
      "label": "Copy into manual"
    },
    "level": {
      "base": {
        "title": "Base translation",
        "subtitle": "Automatic · Linguise Cloud translation",
        "empty": "No base translation for this text.",
        "overridden": "Your selection is saved, but the newest AI enhanced translation is shown instead because “Override manual and selected translations” is Yes in AI Translation settings. Turn that setting off to use your selection."
      },
      "not_generated": "Not generated",
      "none": "Nothing yet",
      "ai": {
        "title": "AI enhanced translation",
        "subtitle": "Automatic · Linguise AI",
        "empty_title": "Not generated for this text yet",
        "empty_description": "Linguise AI gives more natural translations using the context of your page and website. To get one here:",
        "empty_step_1": "Go to AI Translation › Settings and set Enable AI translation to “Rules only”, “Live editor only” or “Rules and live editor”.",
        "empty_step_2": "Apply it with a Rule that matches this page, or enable it page by page from the Live Editor.",
        "empty_step_3": "The AI enhanced translation will appear here once generated. It uses your AI credits.",
        "open_settings": "Open AI Translation settings",
        "open_editor": "Open live editor",
        "overrides_selection": "Your selection is saved, but this AI enhanced translation is shown instead because “Override manual and selected translations” is Yes in AI Translation settings. Turn that setting off to use your selection.",
        "overrides_version": "The version you selected is saved, but the newest AI enhanced version is shown instead because “Override manual and selected translations” is Yes in AI Translation settings. Turn that setting off to use the selected version."
      },
      "manual": {
        "title": "Manual translation",
        "subtitle": "Written by you · has priority over automatic translations",
        "empty": "Empty",
        "saved_but_overridden": "Saved as your choice, but not shown automatically because “Override manual translations” is Yes in AI Translation settings: the AI enhanced translation wins until that setting is turned off.",
        "ignored": "Not shown automatically because “Override manual translations” is Yes in AI Translation settings. Select it to use it for this text.",
        "label": "Your translation",
        "placeholder": "Type your own translation...",
        "last_updated": "Last edited {{date}}",
        "save_hint": "Saving a manual translation makes it active.",
        "delete": "Delete manual translation",
        "delete_confirm": "Please confirm manual translation deletion"
      }
    },
    "history": {
      "title": "AI enhanced versions",
      "subtitle": "Every regeneration from the Live Editor is kept",
      "unknown_model": "Unknown model",
      "current": "Current",
      "restore": "Restore this version",
      "restore_note": "Restoring makes that version the current AI enhanced translation. Nothing is deleted.",
      "version_of": "Version {{current}} of {{total}}",
      "hide": "Hide history ({{total}})",
      "show": "Show history ({{total}})"
    },
    "choose": {
      "title": "Translations in {{language}} · choose the one visitors see",
      "current": "Currently on your website:",
      "priority": "Default priority: Manual › AI enhanced › Base. Your choice is saved for this translation only.",
      "reset": "Reset to default priority",
      "reset_title": "Forget your choice for this text and use the default priority again",
      "resetting": "Resetting ..."
    }
  },
  "translations": {
    "title": "Translations management",
    "description": "List and edit all your website translation, for a visual translation use the Live Editor",
    "filter_languages": "Filter by languages...",
    "filter_original": "Filter text in original language",
    "filter_translation": "Filter by translated text",
    "table": {
      "original": "Original",
      "language": "Language",
      "action": "Action",
      "base": "Base",
      "ai": "AI enhanced",
      "manual": "Manual"
    },
    "filter_exact": "Exact match",
    "badge": {
      "active": "Active",
      "overrides_manual": "Overrides manual"
    },
    "cell": {
      "none": "none",
      "not_generated": "not generated",
      "ignored": "Ignored – AI rule wins"
    },
    "tabs": {
      "all": "All",
      "manual": "Has manual",
      "ai": "Has AI enhanced",
      "base": "Base only"
    },
    "levels_hint": "Each text has up to 3 levels — the one marked Active is what visitors see."
  },
  "url": {
    "main": {
      "parent": "URLs",
      "edit": "Edit URL translation"
    },
    "form": {
      "original": {
        "title": "Original in {{language}}"
      },
      "translation": {
        "title": "URL translation in {{language}}",
        "description": "URL you want to override",
        "placeholder": "Url translation override",
        "invalid_full": "You're trying to change with incorrect format, you should only change the slugs/pathname of the URL translation",
        "invalid": "Invalid URL/path provided"
      }
    }
  },
  "urls": {
    "title": "URLs management",
    "description": "List and edit all your website URLs translated content (advanced, beware of 404 errors)",
    "filter_languages": "Filter by languages...",
    "filter_original": "Filter text in original language",
    "filter_translation": "Filter by translated text",
    "table": {
      "original": "Original",
      "language": "Language",
      "url": "Translated URL",
      "action": "Action",
      "edited": "The original translation has been edited"
    }
  }
}
